import { apiErrorResponse, apiSuccessResponse } from '../constants'
import { ApiResponse } from '../types'

export default async function adapter<T>({
  json,
  response,
}: {
  response: Response
  json: any
}): Promise<ApiResponse<T> | null> {
  const message = json?.message
  const data = json?.data || message
  const status = json?.status

  if (status === 'pending') {
    return apiSuccessResponse({
      ok: true,
      status: response.status,
      result: data,
      response,
      pending: true,
    })
  }

  if (status === 'success' && data) {
    return apiSuccessResponse({
      ok: true,
      status: response.status,
      result: data,
      response,
      pending: false,
    })
  }

  if (status === 'failure') throw new Error(message || data?.message || '')
  return null
}
